<template>
  <div
    class="month-select"
    :class="{
      'is-invalid': invalid,
    }"
  >
    <div
      class="overlay"
      :class="{
        active: container,
      }"
      @click="closeContainer"
    ></div>

    <div class="c-input">
      <div class="hidden-label">
        {{ label }}
      </div>

      <div class="c-input-wrapper">
        <div class="icon" @click="openContainer">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.2222 3H2.77778C1.79594 3 1 3.69645 1 4.55556V15.4444C1 16.3036 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.3036 17 15.4444V4.55556C17 3.69645 16.2041 3 15.2222 3Z"
              stroke="#8E9CBB"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path d="M13 1V5" stroke="#8E9CBB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M5 1V5" stroke="#8E9CBB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <rect x="4" y="8" width="2" height="2" fill="#8E9CBB" />
            <rect x="4" y="12" width="2" height="2" fill="#8E9CBB" />
            <rect x="8" y="8" width="2" height="2" fill="#8E9CBB" />
            <rect x="8" y="12" width="2" height="2" fill="#8E9CBB" />
            <rect x="12" y="8" width="2" height="2" fill="#8E9CBB" />
            <rect x="12" y="12" width="2" height="2" fill="#8E9CBB" />
          </svg>
        </div>

        <div class="c-input-value" @click="openContainer">
          <div class="c-input-value-single">
            {{ getLabel() }}
          </div>
        </div>

        <div
          class="label"
          :class="{
            active: value,
          }"
        >
          {{ label }}
          <!-- <div class="label__info">
            <c-button
              size="iconic"
              icon="info"
              v-b-popover.html="{
                container: '#app',
                trigger: 'hover',
                content: label,
                placement: 'bottom'
              }"
            />
          </div> -->
        </div>
      </div>

      <div
        class="c-input-border"
        :class="{
          active: container,
        }"
      ></div>

      <div
        class="c-input-container"
        :class="{
          active: container,
        }"
      >
        <div class="c-input-container-date">
          <div class="month-select__year">
            <button type="button" class="month-select__prev" @click="prevYear">
              <svg-icon name="chevron-left" :size="14"></svg-icon>
            </button>
            {{ year }}
            <button type="button" class="month-select__next" @click="nextYear">
              <svg-icon name="chevron-right" :size="14"></svg-icon>
            </button>
          </div>
          <div class="month-select__months">
            <div
              v-for="m in months"
              :key="m.id"
              class="month"
              :class="{
                active: year === selectedYear && m.id === selectedMonth,
              }"
              @click="selectMonth(m)"
            >
              {{ m.name.slice(0, 3) }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <error-feedback v-if="error" :text="error"></error-feedback>
  </div>
</template>

<script>
import { ru } from "vuejs-datepicker/dist/locale";
import moment from "moment";

import ErrorFeedback from "@/components/error-feedback";
import SvgIcon from "@/components/svg-icon";

import { MONTHS } from "@/utils/date/months";

export default {
  name: "c-input",

  components: {
    ErrorFeedback,
    SvgIcon,
  },

  props: ["value", "label", "invalid", "error"],

  data() {
    return {
      ru,
      year: null,
      selectedYear: null,
      selectedMonth: null,
      container: false,
      months: MONTHS.map((m, i) => ({
        id: i + 1,
        name: m,
        value: `${i + 1}`.padStart(2, "0"),
      })),
    };
  },

  computed: {
    selectedMonthString() {
      if (!this.selectedMonth) return "";
      return `${this.selectedMonth}`.padStart(2, "0");
    },
    selectedString() {
      if (!this.selectedYear || !this.selectedMonth) return "";
      return `${this.selectedYear}-${this.selectedMonthString}-01`;
    },
  },

  watch: {
    selectedString(value) {
      this.$emit("input", value);
    },

    value(value) {
      if (this.selectedString === value) return;
      this.setDate(value);
    },
  },

  created() {
    this.year = moment().get("year");
    if (this.value) {
      this.setDate(this.value);
    }
  },

  methods: {
    openContainer() {
      this.container = true;
    },

    closeContainer() {
      this.container = false;
    },

    getLabel() {
      if (!this.selectedMonth || !this.selectedYear) return "";
      const month = this.months.find((m) => m.id === this.selectedMonth);
      if (month) return `${month.name} ${this.selectedYear}`;
      return "";
    },

    prevYear() {
      this.year -= 1;
    },

    nextYear() {
      this.year += 1;
    },

    setDate(date) {
      date = moment(date, "YYYY-MM-DD");
      if (date.isValid()) {
        this.selectedYear = date.get("year");
        this.year = this.selectedYear;
        this.selectedMonth = date.get("month") + 1;
      }
    },

    selectMonth(month) {
      this.selectedYear = this.year;
      this.selectedMonth = month.id;
      this.closeContainer();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.month-select {
  min-width: 168px;
  &__year {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 17px;
    border-bottom: 1px solid #dfe4ef;
    font-size: 15px;
    font-weight: 500;
    padding-bottom: 10px;

    button {
      background: transparent;
      border: none;
      box-shadow: none;
      padding: 0;
    }
  }
  &__months {
    margin: -2.5px -3.5px;
    display: flex;
    flex-wrap: wrap;
  }
  .month {
    width: 60px;
    height: 32px;
    border: 1px solid #d3d8df;
    border-radius: 50px;
    margin: 2.5px 3.5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 15px;
    font-weight: 400;

    &:hover {
      border-color: $color-primary;
    }

    &.active {
      background-color: $color-primary;
      border-color: $color-primary;
      color: white;
    }
  }
  .overlay {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 301;
    visibility: hidden;
    opacity: 0;
    transition: 0.2s;

    &.active {
      visibility: visible;
      opacity: 1;

      @include onlyMobile {
        background: rgba(0, 0, 0, 0.7);
        transition: 0.3s;
      }
    }
  }

  .label {
    position: absolute;
    overflow: hidden !important;
    max-width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    left: 0;
    font: 400 15px Fira Sans;
    line-height: 18px;
    color: $color-label;
    padding-bottom: 10px;
    transition: all 200ms;
    display: flex;
    align-items: center;

    &__info {
      display: none;
      margin-left: 4px;
    }

    &.active {
      font-size: 13px;
      transform: translate3d(0, -100%, 0);

      .label__info {
        display: inline-block;
      }
    }
  }

  .hidden-label {
    font-size: 12px;
    visibility: hidden;
    line-height: 13px;
    margin-bottom: 10px;
    color: $color-label;
  }

  .icon {
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    order: 5;
    margin-left: 10px;
    margin-right: 0;

    svg {
      margin-bottom: 5px;
    }
  }
}

.c-input {
  position: relative;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;

  &-wrapper {
    width: 100%;
    display: flex;
  }

  &-value {
    width: 100%;
    height: 30px;
    font-size: 15px;
    padding: 0 0 13px 0;
    cursor: pointer;
    order: 2;
    cursor: pointer;
    height: auto;
    min-height: 30px;
    padding-bottom: 0;
    width: 100%;
    max-width: 100%;

    &-single {
      max-width: 100%;
      margin-top: -2px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  &-border {
    height: 1px;
    width: 100%;
    position: absolute;
    background: $color-control-border;
    bottom: 0;
    transition: 0.2s;

    &.active {
      background: $color-primary;
    }
  }

  &-container {
    position: absolute;
    background: #ffffff;
    box-shadow: $box-shadow-container;
    border-radius: $border-radius-container;
    z-index: 302;
    top: 50px;
    width: 310px;
    box-sizing: border-box;
    transition: 0.2s;
    opacity: 0;
    visibility: hidden;
    padding: 30px 24px;

    &-close {
      display: block;
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 2;
    }

    &.active {
      top: 100%;
      opacity: 1;
      visibility: visible;

      margin-top: 10px;
      left: 0;
    }

    @include onlyMobile {
      position: fixed;
      display: flex;
      flex-direction: column;
      width: 100%;
      height: auto;
      padding: 20px 15px 0px !important;
      transition: none;
      border-radius: 0;

      &__actions {
        margin-left: -15px;
        margin-right: -15px;
        margin-top: 8px;
        display: flex;
      }
      &__action {
        width: 100%;
        height: 38px;
        border: none;
        background: transparent;
        outline: none;
        font-size: 15px;
        font-weight: 500;
      }
      &__apply {
        background: $color-primary;
        color: white;
      }
      &__reset {
        border-top: 1px solid #d3d8df;
        color: black;
      }

      &.active {
        margin-top: 0;
        top: 0%;
        left: 0%;

        /deep/ {
          .c-input-container-calendar {
            margin: 0 auto;

            .day {
              border-radius: 17px;
            }

            .day,
            .day-header {
              height: 34px !important;
            }
          }
        }
      }
    }
  }

  .is-invalid &,
  &.is-invalid {
    .c-input-border {
      background: $color-error;
    }
  }

  .sm {
    display: none;
  }

  @include onlyMobile {
    .sm {
      display: block;
    }
    .lg {
      display: none;
    }
  }
}

@include onlyMobile {
  .month-select {
    &__months {
      width: 270px;
      margin-left: auto;
      margin-right: auto;
    }
  }
  .c-input {
    &-container {
      padding-bottom: 20px !important;
    }
  }
}
</style>
